import { FormStrategy, Handlers, ButtonConfig, TransitionView } from '../../../types'


const buttons = {
  cancel: (handlers: Handlers): ButtonConfig => ({
    labelKey: 'cancel',
    type: 'secondary',
    htmlType: 'button',
    onClick: (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      handlers.handleCancel();
    }
  }),

  save: (): ButtonConfig => ({
    labelKey: 'save',
    type: 'primary',
    htmlType: 'submit',
  }),

  edit: (handlers: Handlers): ButtonConfig => ({
    labelKey: 'edit',
    type: 'primary',
    htmlType: 'button',
    onClick: (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      handlers.handleEdit();
    }
  })
};


export const createFormStrategy = (
  mode: TransitionView,
  handlers: Handlers
): FormStrategy | null => {
  if (mode === 'idle') {
    return null;
  }

  if (mode === 'viewing') {
    return {
      buttons: [
        buttons.edit(handlers),
        buttons.cancel(handlers)
      ],
      isReadOnly: true,
      showBankingNumbers: false,
    };
  }
  if (mode === 'editing') {
    return {
      buttons: [
        buttons.save(),
        buttons.cancel(handlers)
      ],
      isReadOnly: false,
      showBankingNumbers: true,
  }
    }

  return {
    buttons: [
      buttons.save(),
      buttons.cancel(handlers)
    ],
    isReadOnly: false,
    showBankingNumbers: false,
  }
}
